/**
 * PresenceHeartbeat — mount-once component that keeps `users.last_seen_at`
 * fresh while any user is signed in. Renders nothing. Must be mounted
 * INSIDE BrowserRouter (uses useLocation) and INSIDE AuthProvider.
 */
import React from "react";
import { useAuth } from "@/context/AuthContext";
import { usePresenceHeartbeat } from "@/lib/usePresenceHeartbeat";

export default function PresenceHeartbeat() {
    const { user } = useAuth() || {};
    usePresenceHeartbeat(user);
    return null;
}
